import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { ProductsService, User, Product, SubscriptionsService } from '../shared/api';
import { authProvider } from '../shared/auth/authProvider';
import { useHistory } from 'react-router-dom';
import * as Sentry from "@sentry/react";
interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isTextCourse: boolean;
  requireAuth: boolean;
  products: Product[];
  setRequireAuth: (require: boolean) => void;
  login: (email: string, password: string) => Promise<boolean>;
  loginTg: (user: any) => Promise<boolean>;
  logout: () => Promise<void>;
  refreshUser: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

interface AuthProviderProps {
  children: ReactNode;
  defaultRequireAuth?: boolean;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ 
  children, 
  defaultRequireAuth = true 
}) => {
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [requireAuth, setRequireAuth] = useState(defaultRequireAuth);
  const [products, setProducts] = useState<Product[]>([]);
  const [isTextCourse, setTextCourse] = useState<boolean>(false);
  const history = useHistory();

  const refreshUser = async () => {
    try {
      const user = await authProvider.getIdentity();
      setUser(user);
      setIsAuthenticated(!!user);

      if (user) {
        Sentry.setUser({
          id: user.id,
          email: user.email,
          username: user.tg_username,
        });
      }
    } catch (error) {
      console.error('Error refreshing user:', error);
      setUser(null);
      setIsAuthenticated(false);
    }
    getProducts()
    
  };

  useEffect(() => {
    const initializeAuth = async () => {
      try {
        await refreshUser();
      } catch (error) {
        console.error('Error initializing auth:', error);
      } finally {
        setIsLoading(false);
      }
    };

    initializeAuth();
  }, []);

  const login = async (email: string, password: string) => {
    try {
      const success = await authProvider.login(email, password);
      if (success) {
        await refreshUser();
        return true;
      }
      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const loginTg = async (user: any) => {
    try {
      const success = await authProvider.loginTg(user);
      if (success) {
        await refreshUser();
        return true;
      }
      return false;
    } catch (error) {
      console.error('Telegram login error:', error);
      return false;
    }
  };

  const logout = async () => {
    try {
      await authProvider.logout();
      setUser(null);
      setIsAuthenticated(false);
      // history.push('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const getProducts = async () => {
    try {
    const products = await ProductsService.listProducts(1, 100);
    if (products && products.items) {
      setProducts(products.items);
    }
  } catch (error) {
    console.error('Products error:', error);
  }
  return false;
}


  const getUserSubscriptions = async () => {
    try  {
      console.log(user?.id)
      const subscriptions = await SubscriptionsService.getUserSubscriptions(user?.id, 1, 50);
      console.log(user?.email)
      if (subscriptions) {
        console.log("SUB ON")
        for (let i = 0; i < subscriptions.length; ++i) {
          console.log(subscriptions[i])
          if (subscriptions[i].product_id === '040a0a67-ccb9-4778-b153-0245f993a482') {
            setTextCourse(true)
            console.log('textCourse', 'YES YES YES')
          }
        }
      }
      return true;
      } catch (error) {
        console.error('Subscriptions error:', error);
        return false;
      }
  };

  useEffect(() => {
    getUserSubscriptions();
  }, [user]);



  const value = {
    user,
    isAuthenticated,
    isLoading,
    isTextCourse,
    requireAuth,
    products,
    setRequireAuth,
    login,
    loginTg,
    logout,
    refreshUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}; 